import {EtatEmissionEnum} from "@resources/resources";

export class EtatEmissionEnums {

  private static _en_cours: EtatEmissionEnum = 'EN_COURS';
  private static _erreur: EtatEmissionEnum = 'ERREUR';
  private static _termine: EtatEmissionEnum = 'TERMINE';
  private static _termine_en_cours: EtatEmissionEnum = 'TERMINE_EN_COURS';
  private static _deja_emis: EtatEmissionEnum = 'DEJA_EMIS';
  private static _fax_requis: EtatEmissionEnum = 'FAX_REQUIS';

  static EN_COURS = new EtatEmissionEnums(EtatEmissionEnums._en_cours);
  static ERREUR = new EtatEmissionEnums(EtatEmissionEnums._erreur);
  static TERMINE = new EtatEmissionEnums(EtatEmissionEnums._termine);
  static TERMINE_EN_COURS = new EtatEmissionEnums(EtatEmissionEnums._termine_en_cours);
  static DEJA_EMIS = new EtatEmissionEnums(EtatEmissionEnums._deja_emis);
  static FAX_REQUIS = new EtatEmissionEnums(EtatEmissionEnums._fax_requis);

  private static _values = [
    EtatEmissionEnums.EN_COURS.value(),
    EtatEmissionEnums.ERREUR.value(),
    EtatEmissionEnums.TERMINE.value(),
    EtatEmissionEnums.TERMINE_EN_COURS.value(),
    EtatEmissionEnums.DEJA_EMIS.value(),
    EtatEmissionEnums.FAX_REQUIS.value(),
  ];

  constructor(public str: EtatEmissionEnum) {
  }

  value(): EtatEmissionEnum {
    return this.str;
  }

  static values(): Array<EtatEmissionEnum> {
    return this._values;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/enum/EtatEmission.enum.ts